import { Component, OnInit } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase} from '@angular/fire/database';
import { GlobalVars } from '../../../../providers/globalVars';
@Component({
  selector: 'app-servicedetail',
  templateUrl: './servicedetail.page.html',
  styleUrls: ['./servicedetail.page.scss'],
})
export class ServicedetailPage implements OnInit {
  id:any;
  ch:any;
  loclan:any;
  param:any = [];
  toplist:any[] = [];
  btmlist:any[] = [];
  datenow:any = new Date().getTime();
  modal;
  cangoback:boolean = false;
  constructor(private route: ActivatedRoute,public gv:GlobalVars, public afDB: AngularFireDatabase,
    private navCtrl: NavController, private modalCtrl: ModalController) { 
    this.id = this.route.snapshot.paramMap.get('id');
    this.loclan = this.route.snapshot.paramMap.get('loclan');
  }

  ngOnInit() {
    this.getdata();

    //this.setplace()
  }
  ionViewDidEnter() {
    if(this.gv.chreloadrequest)
      this.getdata();
  }
  getdata(){
    this.gv.chreloadrequest = false;
    if(this.loclan && this.id)
    {
    this.afDB.database.ref('/localmanage/'+this.loclan+'/service/'+this.id)
      .once('value').then(rst=>{
      this.param = rst.val()['detail'];
      this.afDB.database.ref(this.gv.getListDir(this.loclan))
      .orderByChild('categoryId').equalTo(this.param['chid'])
      //limitToLast(500).
      .once('value').then(data=>{
      data.forEach(item=>{
        if(item.val().category == this.param['topcat'])
          this.toplist.unshift({key:item.key,data:item.val()});
        if(item.val().category == this.param['btmcat'])
          this.btmlist.unshift({key:item.key,data:item.val()});
      })
      })
    })
    }
  }


  setshare(){
    this.afDB.database.ref('/list')
      .orderByChild('categoryId').equalTo('-LZhq_q-3Nxjhca5kQ8i')
      .once('value').then(rst=>{
        rst.forEach(item=>{
          if(item.val().typemain){
            this.afDB.database.ref('/list/' + item.key).update({selectedform:0}); 
            /*
            //console.log('리스트의' + item.key + '항목 카테고리 쉐어집정보 변경');
            let formdata, fieldlist, room = [];

            if(item.val().rooms)
            {
              let rm = item.val().rooms
              for(let i = 0; i < rm.length; i++)
              {
                room.push({val0:rm[i].roomtype,val0lbl:'방 종류',val1:rm[i].startfrom.slice(0,10),val1lbl:'입주 가능일',
              val2:rm[i].okpax,val2lbl:'인원',val3:'$'+rm[i].price,val3lbl:'주당(1인기준)'})
              }
            }

            fieldlist = {
              0:{mustfill:true,name:'제목',titlefield:'-',type:'normal',value:item.val().title?item.val().title:''},
              1:{mustfill:false,name:'방종류',type:'sp4',value:room?room:''},
              2:{mustfill:true,name:'',type:'textarea',value:item.val().description?item.val().description:''},
              3:{mustfill:false,name:'주소',type:'address',value:item.val().address?item.val().address:''
              ,lat:item.val().lat?item.val().lat:'',lng:item.val().lng?item.val().lng:''},
              4:{mustfill:true,name:'전화번호',type:'contact',value:item.val().contact?item.val().contact:''},
          }
            //formdata = {fieldlist:fieldlist,imgattach:true, name:'쉐어하우스'};
           // console.log(formdata);
            this.afDB.database.ref('/list/' + item.key + '/formdata').set({fieldlist:fieldlist,imgattach:true, name:'쉐어하우스'});*/
          }
        })
      })
  }

  setwork(){
    this.afDB.database.ref('/list')
      .orderByChild('categoryId').equalTo('-LZlOkKnXKkgkqfCGuYP')
      .once('value').then(rst=>{
        rst.forEach(item=>{
          if(item.val().typemain == 'findworker'){
            /*
            let okpax = '';
            if(item.val().okpaxmix && item.val().okpaxmix > 0)
              okpax = '성별무관 ' + item.val().okpaxmix + '명'
            if(item.val().okpaxmale && item.val().okpaxmale > 0)
              okpax = (okpax?okpax+' ':'') + '남자 ' + item.val().okpaxmale + '명'
            if(item.val().okpaxfemale && item.val().okpaxfemale > 0)
              okpax = (okpax?okpax+' ':'') + '여자 ' + item.val().okpaxfemale + '명'
            
            let
            fieldlist = {
              0:{mustfill:true,name:'구인제목',titlefield:'-',type:'normal',value:item.val().title?item.val().title:''},
              1:{mustfill:false,name:'모집인원',type:'selection',value:okpax},
              2:{mustfill:false,name:'근무타입',type:'selection',value:item.val().worktype?item.val().worktype:''},
              3:{mustfill:true,name:'채용조건',type:'normal',value:item.val().condition?item.val().condition:''},
              4:{mustfill:true,name:'근무시간',type:'normal',value:item.val().workhour?item.val().workhour:''},
              5:{mustfill:true,name:'상세설명',type:'textarea',value:item.val().description?item.val().description:''},
              6:{mustfill:true,name:'연락처',type:'contact',value:item.val().contact?item.val().contact:''},
              7:{mustfill:false,name:'근무주소',type:'address',value:item.val().address?item.val().address:''},
             
          }
            //formdata = {fieldlist:fieldlist,imgattach:true, name:'쉐어하우스'};
           // console.log(formdata);
            this.afDB.database.ref('/list/' + item.key + '/formdata').set({fieldlist:fieldlist,imgattach:'', name:'구인'});
            this.afDB.database.ref('/list/' + item.key).update({category:'구인'});
            */
            this.afDB.database.ref('/list/' + item.key).update({selectedform:0});
            
          }
          else
          {
            /*
            let okpax = '';
            if(item.val().okpaxmix && item.val().okpaxmix > 0)
              okpax = '성별무관 ' + item.val().okpaxmix + '명'
            if(item.val().okpaxmale && item.val().okpaxmale > 0)
              okpax = (okpax?okpax+' ':'') + '남자 ' + item.val().okpaxmale + '명'
            if(item.val().okpaxfemale && item.val().okpaxfemale > 0)
              okpax = (okpax?okpax+' ':'') + '여자 ' + item.val().okpaxfemale + '명'
            
            let
            fieldlist = {
              0:{mustfill:true,name:'구직제목',titlefield:'-',type:'normal',value:item.val().title?item.val().title:''},
              1:{mustfill:false,name:'구직인원',type:'selection',value:okpax},
              2:{mustfill:false,name:'구직타입',type:'selection',value:item.val().worktype?item.val().worktype:''},
              3:{mustfill:true,name:'경력 사항',type:'normal',value:item.val().condition?item.val().condition:''},
              4:{mustfill:true,name:'근무 가능시간',type:'normal',value:item.val().workhour?item.val().workhour:''},
              5:{mustfill:true,name:'상세설명',type:'textarea',value:item.val().description?item.val().description:''},
              6:{mustfill:true,name:'연락처',type:'contact',value:item.val().contact?item.val().contact:''}
             
          }
            //formdata = {fieldlist:fieldlist,imgattach:true, name:'쉐어하우스'};
           // console.log(formdata);
            this.afDB.database.ref('/list/' + item.key + '/formdata').set({fieldlist:fieldlist,imgattach:'', name:'구직'});
            this.afDB.database.ref('/list/' + item.key).update({category:'구직'});
            */
            this.afDB.database.ref('/list/' + item.key).update({selectedform:1});
          }
        })
      })
  }

    setplace(){
    this.afDB.database.ref('/list')
      .orderByChild('categoryId').equalTo('-KyU3z4upRvIv0oXJ1gM')
      .once('value').then(rst=>{
        rst.forEach(item=>{
          /*
            let
            fieldlist = {
              0:{mustfill:true,name:'장소 이름',titlefield:'-',type:'normal',value:item.val().title?item.val().title:''},
              1:{mustfill:false,name:'오픈시간',type:'textarea',value:item.val().openhour?item.val().openhour:''},
              2:{mustfill:true,name:'요약설명',type:'hidden',value:item.val().shortdesc?item.val().shortdesc:''},
              3:{mustfill:true,name:'',type:'textarea',value:item.val().description?item.val().description:''},
              4:{mustfill:true,name:'주소',type:'address',value:item.val().address?item.val().address:''
                ,lat:item.val().lat?item.val().lat:'',lng:item.val().lng?item.val().lng:''},
              5:{mustfill:false,name:'연락처',type:'contact',value:item.val().contact?item.val().contact:''},
              6:{mustfill:false,name:'홈페이지',type:'homepage',value:item.val().web?item.val().web:''}
            }
          
           // let formdata = {fieldlist:fieldlist,imgattach:true, name:'장소 등록'};
           // console.log(formdata);
            this.afDB.database.ref('/list/' + item.key + '/formdata').set({fieldlist:fieldlist,imgattach:true, name:'장소 등록'});
            */
            this.afDB.database.ref('/list/' + item.key).update({selectedform:0
              , category:item.val().typemain, subcategory:item.val().typesub?item.val().typesub:''});
          
        })
      })
  }



  close(){
    if(`${this.modal}` != 'undefined') 
      this.modalCtrl.dismiss();
    //if(this.cangoback){
    //  this.navCtrl.pop();}
    else
      this.navCtrl.pop();
      //this.navCtrl.navigateBack('/');
  }
}
